// @flow
import { createTheme } from './utils';
import type { Theme } from './types';

export const theme = (parentTheme: Theme) =>
  createTheme(parentTheme, {
    colors: {
      primary: '#fff',
    },
    brandColors: {
      brandPrimary: '#fff',
    },
  });

export default theme;



// WEBPACK FOOTER //
// ./src/themes/jumbotronC5.js